<template>
    <div class="wrapper wrapper-content animated fadeInRight">
        <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
            <el-tabs type="border-card" v-model="pageLangCode">
                <el-tab-pane :name="langItem.langCode" :label="$t('message.' + langItem.langCode)"
                    v-for="(langItem, index) in langMaps" :key="index">
                    <div class="panel-body">
                        <div class="ibox-content">
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Member No.
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="memberNo" :rules="{
                                        required: true, message: $t('message.required'), trigger: 'change'
                                    }">
                                        <el-input :disabled="!!$route.query.id" v-model="detailInfo.memberNo"
                                            show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Action Type
                                </label>
                                <div class="col-sm-4">
                                    <el-form-item prop="action" :rules="{
                                        required: true, message: $t('message.required'), trigger: 'change'
                                    }">
                                        <el-select :disabled="!!$route.query.id" v-model="detailInfo.action"
                                            v-bind:placeholder='$t("message.PleaseSelect")'>
                                            <el-option v-for="item in actionMap" :key="item.value" :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Quantity
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="stampQty" :rules="{
                                        required: true, message: $t('message.required'), trigger: 'change'
                                    }">
                                        <el-input-number v-model="detailInfo.stampQty" :disabled="!!$route.query.id"
                                            controls-position="right" :max="9999" :min="0"></el-input-number>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Description
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="langItem.descriptionKey" :rules="{
                                        required: true, message: $t('message.required'), trigger: 'change'
                                    }">
                                        <el-input type="textarea" :disabled="!!$route.query.id" :rows="4"
                                            v-model="detailInfo[langItem.descriptionKey]" show-word-limit>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Remark
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="remark" :rules="{
                                        required: false, message: $t('message.required'), trigger: 'change'
                                    }">
                                        <el-input type="textarea" :disabled="!!$route.query.id" :rows="4"
                                            v-model="detailInfo.remark" show-word-limit>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="hr-line-dashed"></div>
                            <div class="form-group">
                                <div class="col-sm-12">
                                    <div class="pull-right">
                                        <el-button type="primary" @click="checkEvent()" v-if="(checkPermission('gift_inventory_log_ADD') &&
                                            !$route.query.id)
                                            ">Save</el-button>
                                        <el-button @click="showWarning()">{{
                                            $t("message.Cancel")
                                        }}</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>

        </el-form>
    </div>
</template>
<script>
import config from "../config";
export default {
    mixins: [config.globalMixin],
    components: {

    },
    data() {
        return {
            detailInfo: {
                memberNo: '',
                stampQty: 0,
                remark: "",
                action: '',
                descriptionEn: '',
                descriptionHk: '',
                descriptionCn: ''
            },
            pageLangCode: 'English'
        };
    },
    computed: {
        _language() {
            return this.$store.state.userInfo.langCode;
        },
        actionMap() {
            return [
                { value: '1', label: "Increase" },
                { value: '2', label: "Reduce" },
            ]
        },
        langMaps() {
            return [
                { langCode: 'English', descriptionKey: 'descriptionEn' },
                { langCode: 'Simplified Chinese', descriptionKey: 'descriptionCn' },
                { langCode: 'Traditional Chinese', descriptionKey: 'descriptionHk' }
            ]
        }
    },
    watch: {
        detailInfo: {
            handler: function () {
                this.$store.state.edit = true;
            },
            deep: true
        }
    },
    created() {
        this.init();
    },
    mounted() { },
    methods: {
        async init() {
            let id = this.$route.query.id;
            var that = this;
            if (id) {
                let obj = this.getAuthObj();
                obj.id = id;
                obj.apiUrl = this.apiConfig.userStampUpdateLogDetail;
                let data = await this.$store.dispatch("apiEvent", obj);
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                this.$set(this, "detailInfo", data.data.result);
                setTimeout(function () {
                    that.$store.state.edit = false;
                }, 500);
            } else {
                setTimeout(function () {
                    that.$store.state.edit = false;
                }, 500);
            }
        },
        checkEvent: function () {
            this.$refs["detailInfo"].validate(valid => {
                if (valid) {
                    this.submit();
                } else {
                    this.$toastr.w(this.$i18n.t("message.fillRequired"));
                    return false;
                }
            });
        },
        showWarning(type) {
            var that = this;
            if (!type) {
                that.$router.go(-1);
            } else if (type == 1) {
                this.$store.commit("setwarning", {
                    string: this.$i18n.t("message.deleteContent"),
                    boolean: true,
                    button: [
                        {
                            name: this.$i18n.t("message.Confirm"),
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false
                                });
                                that.callDelete();
                            }
                        },
                        {
                            name: this.$i18n.t("message.Cancel"),
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false
                                });
                            }
                        }
                    ]
                });
            }
        },
        async submit() {
            try {
                let obj = this.getAuthObj();
                for (var key in this.detailInfo) {
                    if (key != "userId") obj[key] = this.detailInfo[key];
                }
                var data;
                obj.apiUrl = this.apiConfig.userStampUpdateLogCreate;
                data = await this.$store.dispatch("apiEvent", obj);
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                if (data.data.status_code === "0") {
                    this.$store.state.edit = false;
                    this.$router.go(-1);
                }
            } catch (err) { }
        },
    }
};
</script>
  